import React from 'react';
import cx from 'classnames';
import styles from './RecordNotFound.module.scss';
import { useTranslation } from 'react-i18next';

const IconA = () => (
  <svg width="109" height="109" viewBox="0 0 109 109" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M86.9102 0.5H0.910156V86.5H86.9102V0.5Z" fill="#EEEEEE" />
    <path
      d="M43.9906 48.6647C52.8427 48.6647 60.8454 54.247 63.9063 62.5463L58.5262 64.5284C56.2946 58.4674 50.4561 54.3953 43.9973 54.3953C37.4442 54.3953 31.5787 58.5416 29.4011 64.7104L23.994 62.8025C26.974 54.3481 35.0104 48.6647 43.9906 48.6647Z"
      fill="white"
    />
    <path
      d="M37.6058 34.3243H31.8752C31.8752 30.8454 29.0435 28.0206 25.5714 28.0206C22.0994 28.0206 19.2677 30.8522 19.2677 34.3243H13.5371C13.5371 27.6835 18.9374 22.2832 25.5782 22.2832C32.219 22.2832 37.6058 27.6835 37.6058 34.3243Z"
      fill="white"
    />
    <path
      d="M74.2952 34.3243H68.5646C68.5646 30.8454 65.733 28.0206 62.2609 28.0206C58.7888 28.0206 55.9572 30.8522 55.9572 34.3243H50.2266C50.2266 27.6835 55.6268 22.2832 62.2676 22.2832C68.9084 22.2832 74.2952 27.6835 74.2952 34.3243Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.5093 71.7247C83.4437 70.5567 85.148 70.3673 86.316 71.3017L99.8577 82.1351C101.026 83.0695 101.215 84.7738 100.281 85.9418C99.3463 87.1098 97.6419 87.2992 96.4739 86.3648L82.9323 75.5315C81.7643 74.5971 81.5749 72.8927 82.5093 71.7247Z"
      fill="#7C43AA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.7285 76.1248C77.9553 76.1248 84.6243 69.4557 84.6243 61.229C84.6243 53.0023 77.9553 46.3332 69.7285 46.3332C61.5018 46.3332 54.8327 53.0023 54.8327 61.229C54.8327 69.4557 61.5018 76.1248 69.7285 76.1248ZM69.7285 81.5415C80.9468 81.5415 90.041 72.4473 90.041 61.229C90.041 50.0107 80.9468 40.9165 69.7285 40.9165C58.5102 40.9165 49.416 50.0107 49.416 61.229C49.416 72.4473 58.5102 81.5415 69.7285 81.5415Z"
      fill="#7C43AA"
    />
  </svg>
);

export default function RecordNotFound(props) {
  const { className, searchTerm, ...rest } = props;
  const { t } = useTranslation();

  return (
    <div className={cx(styles.searchNotFound, className)} {...rest}>
      <div className={cx(styles.wrapper)}>
        <div className={cx(styles.iconWrapper)}>
          <div className={cx(styles.iconA)}>
            <IconA />
          </div>
        </div>
        <div className={cx(styles.title)}>
          {searchTerm ? `${t('dashboard.searching.no_matches')} '${searchTerm}'` : t('dashboard.searching.no_matches_empty')}
        </div>
      </div>
    </div>
  );
}
